import { useState } from 'react';
import Language from '@mui/icons-material/Language';
import { MenuItem as MuiMenuItem } from '@mui/material';
import MuiSelect, { SelectChangeEvent } from '@mui/material/Select';

import { useI18n } from '@openclassrooms/translations/I18nProvider';

import { styled } from '@classify/react-core-components/styles';
import Box from '@classify/react-core-components/Box';

interface Props {
  onChangeLang?: (newLang: string) => void;
}

const AVAILABLE_LANGS = [
  {
    label: 'Français',
    value: 'fr',
  },
  {
    label: 'English',
    value: 'en',
  },
];

const Root = styled(Box)({ display: 'flex', alignItems: 'center', justifyContent: 'content' });

const MenuItem = styled(MuiMenuItem)({
  '&$menuItem': {
    boxSizing: 'content-box',
    fontWeight: 'normal',
  },
});

const Select = styled(MuiSelect)(({ theme: { breakpoints } }) => ({
  width: '200px',
  [breakpoints.up('sm')]: {
    width: '100%',
  },
}));

const LangSelector = ({ onChangeLang }: Props) => {
  const { i18n, translate } = useI18n();

  const [selectedLang, setSelectedLang] = useState<string>(i18n.lang);

  return (
    <Root>
      <Language
        sx={{
          verticalAlign: 'middle',
          paddingRight: 1,
          color: 'text.onMain',
        }}
      />
      <Box sx={{ flex: 1 }}>
        <Select
          id="footerChangeLanguage"
          onChange={(event: SelectChangeEvent<string>) => {
            const newLang = event.target.value;
            onChangeLang?.(newLang);
            setSelectedLang(newLang);
          }}
          value={selectedLang}
          inputProps={{ 'aria-label': translate('footer.language.title') }}
          variant="standard"
        >
          {AVAILABLE_LANGS.map(({ label, value }) => (
            <MenuItem key={value} value={value}>
              {label}
            </MenuItem>
          ))}
        </Select>
      </Box>
    </Root>
  );
};

export default LangSelector;
